import { capitalCase } from 'capital-case';
export function getAuthorFullName(author) {
    return capitalCase([author.details.firstName, author.details.lastName].filter(Boolean).join(' '));
}
